import React from 'react'

import { CmsContainerPage, CmsHeadTags, CmsPageLayout } from '@grandvisionhq/bloomreach'
import { Container } from '@grandvisionhq/elements'
import { ErrorPage } from '@grandvisionhq/layout'
import { NextPage } from '@grandvisionhq/next'

import { withCms } from '../cms'
import { defaultErrorProps } from '../components/error-props'

type InitialProps = {
  statusCode: number | undefined
}

type Props = InitialProps

const Error: NextPage<InitialProps, Props> = ({ statusCode }) => {
  const ErrorContent = (
    <React.Fragment>
      <CmsHeadTags title={defaultErrorProps.title} noIndex={true} noFollow={true} />
      <Container className="error-layout">
        <ErrorPage
          header={defaultErrorProps.title}
          subheader={defaultErrorProps.subheader}
          buttonText={defaultErrorProps.buttonText}
        />
      </Container>
    </React.Fragment>
  )

  // We only receive a pageModel on 200 and 404 responses
  if (statusCode === 404) {
    return (
      <CmsContainerPage>
        <CmsPageLayout>{ErrorContent}</CmsPageLayout>
      </CmsContainerPage>
    )
  }

  return ErrorContent
}

Error.getInitialProps = ({ res, err }) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 500
  return { statusCode }
}

export default withCms({ wrapInContainerPage: false })(Error)
